<template>
  <main
  @click="onClick"
  :style=squareStyle
  >
    <div
    v-if="squareType === 3"
    :style=pawnStyle
    />
  </main>
</template>

<script>


export default {
  components: { },
  name: 'square',
  props: {
    squareType: Number,
    ii: Number,
    jj: Number,
    active: Boolean,
    disabled: Boolean,
  },
  data() {
    return {
      squareColor: {
        0: '#80bfff',
        1: '#ff884d',
        2: 'white',
        3: 'white',
        4: 'white',
      },
    };
  },
  computed: {
    squareStyle() {
      return {
        width: '60px',
        height: '60px',
        display: 'inline-block',
        backgroundColor: this.squareColor[this.squareType],
        transition: 'background 1s ease',
        border: `${this.squareType >= 3 ? 0 : 1}px solid #000`,
      };
    },
    pawnStyle() {
      return {
        width: '20px',
        height: '20px',
        margin: '20px',
        backgroundColor: this.backgroundColor,
        borderRadius: '20px',
        border: '2px solid #000',
      };
    },
    backgroundColor() {
      if (this.active) {
        return 'black';
      }
      if (this.disabled) {
        return 'LightGray';
      }
      return 'white';
    },
  },
  methods: {
    onClick() {
      this.$emit('clicked', this.ii, this.jj);
    },
  },
};
</script>

<style scoped>

</style>
